import Route from '@ember/routing/route';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { PROJECT_DETAILS__SUB_NAV_TITLES } from 'sh-www/constants/routes/project-details';

class ProjectDetailsDetailsRoute extends Route {
  /** @inheritDoc */
  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/project/:id/details/');
    this.controllerFor('project-details').updateSubNavState(PROJECT_DETAILS__SUB_NAV_TITLES.DETAILS);
  }
}

export default ProjectDetailsDetailsRoute;
